<section id="reviews-page">

  <div class="container">
    <div class="row top-row">
      <div class="col-md-12 bg-form">
        <div class="row top-text">
          <div class="col-lg-12">
            <h1>Leave a Tip For Me</h1>
            <span>If you are satisfied with my service you can leave an optional gratuity, tips are appreciated but not expected.</span>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-5">
            <div class="row tip-amount">
              <div class="col-lg-12">
                <p>Tip amount: <span>{{amount | currency:'USD':true:'1.0-0'}}</span></p>
              </div>

              <div class="col-lg-12">
                <div class="btn-group amount-group" role="group">
                  <div class="row">
                    <input (click)="amount = 50; amountChanged();" type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off"
                           [attr.checked]="amount === 50? true : undefined" >
                    <label class="btn btn-outline-primary" for="btnradio1">$50</label>

                    <input (click)="amount = 100; amountChanged();" type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off"
                           [attr.checked]="amount === 100? true : undefined">
                    <label class="btn btn-outline-primary" for="btnradio2">$100</label>
                  </div>
                  <div class="row">
                    <input (click)="amount = 150; amountChanged();" type="radio" class="btn-check" name="btnradio" id="btnradio3" autocomplete="off"
                           [attr.checked]="amount === 150? true : undefined">
                    <label class="btn btn-outline-primary" for="btnradio3">$150</label>

                    <input (click)="amount = 200; amountChanged();" type="radio" class="btn-check" name="btnradio" id="btnradio4" autocomplete="off"
                           [attr.checked]="amount === 200? true : undefined">
                    <label class="btn btn-outline-primary" for="btnradio4">$200</label>
                  </div>
                  <div class="row">
                    <input (click)="amount = 250; amountChanged();" type="radio" class="btn-check" name="btnradio" id="btnradio5" autocomplete="off"
                           [attr.checked]="amount === 250? true : undefined">
                    <label class="btn btn-outline-primary" for="btnradio5">$250</label>

                    <input (click)="amount = 350; amountChanged();" type="radio" class="btn-check" name="btnradio" id="btnradio6" autocomplete="off"
                           [attr.checked]="amount === 350? true : undefined">
                    <label class="btn btn-outline-primary" for="btnradio6">$350</label>
                  </div>
                </div>
              </div>


            </div>
          </div>

          <div class="col-lg-7">
            <form class="row g-3" id="paymentForm" [formGroup]="paymentForm" action="/charge" method="post">
              <div class="mt-3 col-md-6">
                <label for="Name" class="form-label">Name of card</label>
                <input type="text" class="form-control" id="Name" placeholder="John Doe" formControlName="name"
                       [ngClass]="{ 'has-error': triedSubmit && !paymentForm.get('name').valid }"
                       [attr.disabled]="formSending ? '' : null">
              </div>

              <div class="mt-3 col-md-6">
                <label for="Email" class="form-label">Email</label>
                <input type="text" class="form-control" id="Email" placeholder="example@com" formControlName="email"
                       [ngClass]="{ 'has-error': triedSubmit && !paymentForm.get('email').valid }"
                       [attr.disabled]="formSending ? '' : null">
              </div>

              <div class="mt-3 col-md-5">
                <label for="CardNumber" class="form-label">Card Number</label>
                <input type="text" class="form-control" id="CardNumber" placeholder="1234XXXXXXXXXXX" formControlName="card"
                       [ngClass]="{ 'has-error': triedSubmit && !paymentForm.get('card').valid }"
                       [attr.disabled]="formSending ? '' : null"
                       [textMask]="{
            mask: cardMask,
            placeholderChar: ' ',
            keepCharPositions: true,
            showMask: false
          }">
              </div>

              <div class="mt-3 col-8 col-md-5">
                <div class="mt-0 p-0 pr-1 col-12 col-md-12 d-inline-block">
                  <label for="MM" class="form-label">Expiration Date</label>
                </div>

                <div class="mt-0 p-0 pr-1 col-6 col-md-6 d-inline-block">
                  <select id="MM" class="form-select" placeholder="MM" formControlName="month"
                          [ngClass]="{ 'has-error': triedSubmit && !paymentForm.get('month').valid }"
                          [attr.disabled]="formSending ? '' : null">
                    <option selected>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                    <option>10</option>
                    <option>11</option>
                    <option>12</option>
                  </select>
                </div>
                <div class="mt-0 p-0 pl-1 col-6 col-md-6 d-inline-block">
                  <select id="YY" class="form-select" placeholder="YY" formControlName="year"
                          [ngClass]="{ 'has-error': triedSubmit && !paymentForm.get('year').valid }"
                          [attr.disabled]="formSending ? '' : null">
                    <option *ngFor="let year of cardExpirationYearsList"
                            [selected]="lastExpirationYear === year">
                        {{year}}
                    </option>
                  </select>
                </div>
              </div>

              <div class="mt-3 col-4 col-md-2">
                <label for="CVVCode" class="form-label">CVV</label>
                <input type="text" class="form-control" id="CVVCode" placeholder="123" formControlName="cvv"
                       [ngClass]="{ 'has-error': triedSubmit && !paymentForm.get('cvv').valid }"
                       [attr.disabled]="formSending ? '' : null"
                       [textMask]="{
            mask: cvvMask,
            placeholderChar: ' ',
            keepCharPositions: true,
            showMask: false
          }">
              </div>

              <div class="col-lg-12">
                <div  class="button-block">
<!--                  <button type="button" class="btn btn-apple-pay btn-lg"></button>-->
<!--                  <apple-pay-button *ngIf="applePayAvailable" buttonstyle="black" type="buy" locale="el-GR"></apple-pay-button>-->
<!--                  <div id="applePayContainer" class="apple-pay-button apple-pay-button-black btn"  (click)="onApplePayClick()"></div>-->
                  <div id="applePayContainer" class="apple-pay-button apple-pay-button-black btn"></div>
                    <!-- Any error messages will be inserted here. -->

                  <button type="button" class="btn btn-card btn-lg" (click)="pay()"
                          [attr.disabled]="formSending ? '' : null">Pay Now</button>
                </div>
              </div>

              <div *ngIf="submitted" class="col-lg-12 thank-after">
                <img alt="" class="service-block-icon ng-lazyloaded" height="50" width="50" ng-reflect-lazy-image="/assets/img/icons/checkmark_circle_outlined.svg" src="/assets/img/icons/checkmark_circle_outlined.svg">
                <p>Thank you for the tip! 😊</p>
              </div>
               <div id="paymentCardErrorContainer"role="alert"> </div>

            </form>
          </div>
        </div>

      </div>
    </div>
  </div>

</section>
